module.exports = "/shared/fonts/tutorial-regular.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/ui/fonts/tutorial-regular.ttf
// module id = 27
// module chunks = 13